import { Container } from './FloatingElement.styled';

export interface FloatingElementProps {
  isMounted: boolean;
  isExpanded: boolean;
  children: React.ReactNode;
  className?: string;
}

const FloatingElement: React.FC<FloatingElementProps> = ({
  isMounted,
  isExpanded,
  children,
  className,
}) => {
  if (!isMounted) return null;

  return (
    <Container $isExpanded={isExpanded} className={className} role="dialog">
      {children}
    </Container>
  );
};

export default FloatingElement;
